import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

function galleryInit ($container = $('body')) {
	$container.find('[data-gallery]').each(function () {
		lightGallery(this, {
			plugins: [lgZoom, lgThumbnail],
			selector: '[data-gallery-element]',
			download: false,
			share: false,
			rotate: false,
			autoplayControls: false,
			hash: false,
			exThumbImage: 'data-thumb'
		});
	});
}

export default galleryInit;



// WEBPACK FOOTER //
// ./src/js/_modules/lightgallery.js